export const setDistributorDetails = (details) => ({
    type: 'SET_DISTRIBUTOR_DETAILS',
    details
});